module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTK23x623x6+6yK+3x6+5yK64x6+yza+5yK63yK+5yJr9VG4AAAAKdFJOUwCAQ+Qit2oQn5Dj4J6SAAAA0UlEQVQoz2NgIAmwJwoiAyEHsGjyKlSwECTItgodJABFmTFEzYGiWhiiy4CiWRiiIIOlaCSahdUNXhiiS4CirCDGUmUw36gLRAYARVmsgAwTNhC5SqEYSCwGB48zUKkDiFwVwsASBVQBCUrNTgUGBQbFjiQGFgamGZMQYVy6sAAU0lEtcBEmdXZFq1UW6gxOk1ctFioogoQ6F5rDDLCKLhi6okFKIKCKJqoACRKi1BJpGzPWkGTEknyB8WKFIri4ABJFriiiIbCYU0PKLEkMJAIADDtmAF8SPdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/wsc.png
// module id = eGaG
// module chunks = 1